import { motion } from "framer-motion";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { handleScroll } from "../util/HomeRouteHelper";

export const HomeListing = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <div id="home">
      <div className="flex min-h-screen">
        <div className="flex-grow bg-[#e1e1e1] flex flex-col justify-center items-center">
          <motion.div
            className="max-w-xl px-4"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="mb-6 text-3xl font-bold">
              {intl.formatMessage({ id: "home.title" })}
            </div>
            <div className="border-l-4 ps-4 border-[#6e5f49] mb-8 text-xl">
              {intl.formatMessage({ id: "home.desc" })}
            </div>
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate("/quote/phone")}
                className="bg-[#6b5c45] border-2 border-[#3f3525] text-white px-4 py-2 rounded-full hover:bg-[#3f3525] transition font-semibold"
              >
                {intl.formatMessage({ id: "getQuotation" })}
              </button>
              <button
                onClick={() => handleScroll("about")}
                className="border-2 border-[#3f3525]  px-4 py-2 rounded-full hover:bg-[#cecac3] transition font-semibold"
              >
                {intl.formatMessage({ id: "moreInfo" })}
              </button>
            </div>
          </motion.div>
        </div>

        <div className="relative hidden w-1/2 min-h-full md:flex">
          <img
            src="/image/landingPage/home.jpg"
            className="hidden w-full min-h-full md:flex"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-30" />
        </div>
      </div>
    </div>
  );
};
